import { render, staticRenderFns } from "./ValiCodeCom.vue?vue&type=template&id=4f8a7f94&scoped=true"
import script from "./ValiCodeCom.vue?vue&type=script&lang=js"
export * from "./ValiCodeCom.vue?vue&type=script&lang=js"
import style0 from "./ValiCodeCom.vue?vue&type=style&index=0&id=4f8a7f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a7f94",
  null
  
)

export default component.exports